import * as Yup from 'yup';
import { ProgressItem } from '../../../../../../global/components/navigation/generic-stepper';
import { postNewPerson } from '../../../../../../global/ducks/person-prc-api';
import { parseChanged, parsePhone } from '../../../../../../global/helpers/form-data-helper';
import { LabelSettingProps } from '../../../../../../global/models/epi-model';
import { PersonInfoValidationSchema } from '../../../../../../global/validation-schemas/account-information-form-validation';
import { NewHireMailingAddressValidationSchema } from '../../../../../../global/validation-schemas/address-form-validation';
import { AccountInfoRoutes } from '../../../../../account-info/constants/routes';
import { NewHireProps, noSelectPersonId } from '../../../../models/arc-epi-props';
import { NewHireStep } from '../../../new-hire/models/new-hire-model';

export function getNewParticipantStepItems(settings: NewHireProps) {
	const progressItem: ProgressItem[] = [];
	progressItem.push(
		{
			stepName: settings?.personInfoStepName,
			linkUrl: AccountInfoRoutes.PersonalInfoSegment,
			step: NewHireStep.PersonalInfo,
		},
	);


	return progressItem;
}

export function getNewParticipantValidationSchema(labelSetting: LabelSettingProps, hasSearchResults: boolean) {
	return Yup.lazy(({
		date_of_birth,
		business_phone_formated,
		business_phone_country_code,
		mobile_phone_formated,
		mobile_phone_country_code,
		home_phone_formated,
		home_phone_country_code,
		matched_person,
	}) => {
		let schema = Yup.object().shape({});

		if (hasSearchResults && matched_person !== noSelectPersonId ) {
			schema = schema.shape({
				matched_person: Yup.string().nullable().required(labelSetting.selectMatchPersonRequired),
			});
		} else {

			schema = schema.shape({
				...PersonInfoValidationSchema(labelSetting, date_of_birth,
					{
						business_phone_formated,
						business_phone_country_code,
						mobile_phone_formated,
						mobile_phone_country_code,
						home_phone_formated,
						home_phone_country_code,
					}),
				...NewHireMailingAddressValidationSchema(labelSetting),
				personal_email_address: Yup.string().email(labelSetting.emailFormatError).ensure().when('office_email_address', {
					is: '',
					then: Yup.string().required(labelSetting.atLeastOneEmail),
				}),
				office_email_address: Yup.string().email(labelSetting.emailFormatError).ensure().when('personal_email_address', {
					is: '',
					then: Yup.string().required(labelSetting.atLeastOneEmail),
				}),
			},
				[['office_email_address', 'personal_email_address']]);

		}
		return schema;
	});

}

export function OnCancel(history: any) {
	history.goBack();
}

export function OnSubmit(value: any, initialValue: any, dispatch: any, onSuccess: any) {
	const withPhoneUpdate = parsePhone(value);
	const toUpdate = parseChanged(initialValue, withPhoneUpdate, true);
	dispatch(postNewPerson(toUpdate, (res) => onSuccess(res)));
}